// extracted by mini-css-extract-plugin
module.exports = {"dataContent":"Innerhtml_dataContent__1hkcI","editorArea":"Innerhtml_editorArea__WLqk3","tableWrapper":"Innerhtml_tableWrapper__N2KBq"};